import { ASSISTANCE_PRICING, CREDITS_PRICING, ID_TRACKER_PRICING } from "shared/config/pricings";
import { FC, useContext, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import DocumentIllustration from "components/DocumentIllustration";
import ResultAfterPayment from "components/ResultAfterPayment";
import StripePaymentCard from "./components/StripePaymentCard";
import { UserContext } from "features/account";
import { getOfferPlan } from "utils/utils";

const StripePayment: FC = () => {
    const navigate = useNavigate();

    const { offer, planIndex, isMonth } = useParams();

    const { user } = useContext(UserContext);
    const [message, setMessage] = useState("");
    const [title, setTitle] = useState("");
    const [paymentSucceeded, setPaymentSucceeded] = useState(false);

    const type = user?.type ?? 'individual'

    const [datas, setDatas] = useState<any>({
        user: user,
        addresse: "",
        postalCode: "",
        city: "",
        comment: "",
        documents_ids: "",
        pv: [],
        chosenPlan: getOfferPlan(offer, parseInt(planIndex || "0")) ?? ID_TRACKER_PRICING[1],
    });

    const [steps, setSteps] = useState([
        { isCurrent: true, isDone: false },
        { isCurrent: false, isDone: false },
    ]);

    const handleUpdateStep = (step: number) => {
        setSteps(
            steps.map((s, index) => {
                if (index === step) {
                    return { isCurrent: true, isDone: false };
                } else if (index < step) {
                    return { isCurrent: false, isDone: true };
                }
                return { isCurrent: false, isDone: false };
            }),
        );
    };

    const handleNextStep = () => {
        const currentStep = steps.findIndex((step) => step.isCurrent);
        if (currentStep < steps.length - 1) {
            handleUpdateStep(currentStep + 1);
        }
    };

    const handlePreviousStep = () => {
        const currentStep = steps.findIndex((step) => step.isCurrent);
        if (currentStep > 0) {
            handleUpdateStep(currentStep - 1);
        }
    };

    const handlePaymentResult = (title: string, message: string, paymentSucceeded: boolean) => {
        handleNextStep();
        setTitle(title);
        setMessage(message);
        setPaymentSucceeded(paymentSucceeded);
    };

    return (
        <div className="StripePayment">
            <div className="content__body ">
                <div className="row">
                    <div className={`col-sm-6`}>
                        <div className="content--card">
                            {steps[0].isCurrent && (
                                <StripePaymentCard
                                    isMonth={isMonth === "month" ? true : isMonth === "year" ? false : undefined}
                                    title={datas.chosenPlan.title}
                                    link={`${user?.type === 'partner' ? 'professionnels' : 'particuliers'}/profil`}
                                    setDatas={setDatas}
                                    datas={datas}
                                    handlePreviousStep={() => {
                                        navigate(-1);
                                    }}
                                    handlePaymentResult={handlePaymentResult}
                                />
                            )}
                            {steps[1].isCurrent && (
                                <ResultAfterPayment
                                    title={title}
                                    message={message}
                                    pageSucceeded={paymentSucceeded}
                                    steps={steps}
                                    handlePreviousStep={handlePreviousStep}
                                    handleNextStep={() => (window.location.href = `${type === 'individual' ?
                                      '/particuliers/profil': 
                                      '/professionnels/profil'
                                    }`)}
                                />
                            )}
                        </div>
                    </div>
                    <div className={`col-sm-5 center`}>
                        <div>
                            <DocumentIllustration type={"payment"} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default StripePayment;
